import * as React from "react"
import { CalendarIcon, CasinoIcon } from "../atoms/Icons"
import LanguagePicker from "../atoms/LanguagePicker"
import Logo from "../atoms/Logo"

import * as styles from './styles.module.scss'

const Header = () => {
  return (
    <div className={styles.header}>
      <Logo />
      <div className={styles.controls}>
        <LanguagePicker />
        <a href="/?bt-path=%2Fschedule" className={styles.link}><CalendarIcon /> Upcoming Matches</a>
        <a href="/live-casino" className={styles.link}><CasinoIcon /> Live Casino</a>
      </div>
    </div>
  )
}

export default Header